<template>
    <div>
        <despesa v-if="mostrarDespesa"
            :despesa="despesa"
            :temAcessoDetalharItem="$temAcessoView('DESP-GERAIS-FINAN-00')"
            :temAcessoHistorico="$temAcessoView('DESP-GERAIS-FINAN-00')"
            :rotaDetalharItem="'DespesasGerais_Financeiro_ItensDespesa_Detalhar'"
            :temAcessoAnexos="$temAcessoView('DESP-GERAIS-FINAN-00')"
            :mostrarAnexos="mostrarAnexos"
            :anexos="anexos"
            @mostrarAnexos="obterAnexos()"
            @baixarAnexo="baixarAnexo($event)"
            @fecharAnexos="fecharAnexos()"
            :servicos="obterServicos()"
        >
            <template slot="footer">
                <app-btn-voltar></app-btn-voltar>
            </template>
        </despesa>
        <router-view></router-view>
    </div>
</template>

<script>
import Despesa from '@/app/despesasgerais/componentes/despesas/Despesa.vue';
import DespesasServicos from './DespesasServicos'
import DespesasAnexosServicos from './DespesasAnexosServicos'

export default {
    data() {
        return {
            despesa: null,
            mostrarAnexos: false,
            anexos: [],
        }
    },

    components: {
        Despesa
    },

    methods: {
        obterDespesa() {
            this.$store.dispatch('addRequest')
            DespesasServicos.obterPorId(this.$route.params.despesaId).then(response => {
                if (response) {
                    if (response.success) {
                        this.despesa = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterAnexos() {
            this.$store.dispatch('addRequest')
            DespesasAnexosServicos.obterAnexos(this.$route.params.despesaId).then(response => {
                if (response) {
                    if (response.success) {
                        this.anexos = response.data
                        this.mostrarAnexos = true
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        baixarAnexo(anexo) {
            DespesasAnexosServicos.baixarAnexo(anexo).then(response => {
                if (response) {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro ao realizar download do anexo!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(
                                response,
                                anexo.nomeArquivoOriginal
                            )
                        }
                    }
                }
            })
        }, 

        fecharAnexos() {
            this.mostrarAnexos = false
        },

        obterServicos() {
            return DespesasServicos
        }
    },

    created() {
        this.obterDespesa()
    },

    computed: {
        mostrarDespesa() {
            return this.$route.name === 'DespesasGerais_Financeiro_Despesas_Detalhar'
        }
    },
}
</script>